export default __webpack_public_path__ + "static/media/message.c3c4e80f.svg";